import { Pipe, PipeTransform } from '@angular/core';
import { truncateNotificationPreview } from '@app/core/utils/notification-content.utils';

@Pipe({
  name: 'notificationPreview',
})
export class NotificationPreviewPipe implements PipeTransform {
  transform(content?: string | null, maxLength = 120): string {
    return truncateNotificationPreview(content, maxLength);
  }
}
